export default "__VITE_ASSET__465c25bb__"